import { useEffect, useMemo, useRef } from 'react';

import datadog, { customAction } from '@/tracking/datadog';
import configureGTM from '@/tracking/googleTagManager';
import type { GTMType } from '@/tracking/TrackingTypes';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function useTrackingProviders(settings: any) {
  const gtmRef = useRef<(id: number, data: GTMType) => void>(() => {});

  useEffect(() => {
    datadog(settings);
    gtmRef.current = configureGTM(settings);
  }, [settings]);

  return {
    gtmTrackEvent: useMemo(() => gtmRef.current, [gtmRef]),
    ddTrackAction: useMemo(() => (topic: string) => customAction(topic), []),
  };
}
